import {
  Button,
  Flex,
  Heading,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { MenuLocationsContext } from '../../../../hooks/useMenuItemsLocation';
import MenuItemsLocationModal from '../../components/MenuItemsLocation';
import Item from './Item';

const List: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [locationToEdit, setLocationToEdit] = useState<any | null>(null);

  const { data: dataFromContext, loading } = useContext(MenuLocationsContext);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Flex
      flexDir="column"
      w="100%"
      p={8}
      overflow="auto"
      bg="#F9F9F9"
      css={{
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#469BFF',
          borderRadius: '24px',
        },
      }}
    >
      <MenuItemsLocationModal
        isOpen={isOpen}
        locationToEdit={locationToEdit}
        onClose={() => {
          onClose();
          setLocationToEdit(null);
        }}
      />
      <Heading mb="48px" color="#469BFF" fontFamily="Poppins">
        Localizações de Menus
      </Heading>
      <Button
        textAlign="center"
        ml="4"
        fontWeight="300"
        fontFamily="Poppins"
        position="relative"
        padding="10px"
        width="fit-content"
        aria-label="create_page"
        rounded="md"
        colorScheme="brand"
        onClick={() => onOpen()}
      >
        Nova localização para menus
      </Button>
      <Flex
        position="relative"
        flexDir="column"
        bg="#F9F9F9"
        p={4}
        mt={3}
        borderRadius={6}
      >
        <TableContainer>
          <Table variant="simple">
            <Thead borderRadius="14px" overflow="hidden" width="305%">
              <Tr>
                <Th textColor="#469BFF" fontFamily="Poppins">
                  Página
                </Th>
                <Th textColor="#469BFF" fontFamily="Poppins">
                  Slug
                </Th>
                <Th textColor="#469BFF" fontFamily="Poppins">
                  Ações
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {dataFromContext ? (
                // eslint-disable-next-line array-callback-return, consistent-return
                dataFromContext.map((location: any) => (
                  <Item
                    key={location?.id}
                    location={location}
                    onEditClick={() => {
                      setLocationToEdit(location);
                      onOpen();
                    }}
                  />
                ))
              ) : (
                <Text color="red">Não foi encontrado nenhum item</Text>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        {loading && (
          <Flex
            position="absolute"
            align="center"
            justify="center"
            top="50%"
            left="50%"
          >
            <Spinner color="brand.500" size="xl" />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default List;
